/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "../../components/ButtonUse.jsx";
import { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { MdDelete } from "react-icons/md";
import { Delete } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import Swal from "sweetalert2";

// Dashboard components

function AddNewBmShape() {
  const [name, setName] = useState("");
  const postData = async () => {
    const requestBody = {
      name: name,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/postBodyMeasurement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      fetchData();
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setName("");

      const responseData = await response.json();
      console.log("Response data:", responseData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [bodyData, setBodyData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/getBodyMeasurement`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const responseData = await response.json();
      setBodyData(responseData.data);
    } catch (error) {
      console.error("Error fetching body data:", error);
    }
  };

  const deleteBodyDataImages = async (_id) => {
    try {
      const isConfirmed = window.confirm("Are you sure you want to delete this item?");
      if (!isConfirmed) return;

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/deleteBodyMeasurement/${_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete data");
      }

      console.log("Body data images deleted successfully");
      fetchData();
    } catch (error) {
      console.error("Error deleting body data images:", error.message);
    }
  };

  // const handleDeleteButtonClick = () => {
  //   if (selectedOption) {
  //     deleteBodyDataImages(selectedOption._id);
  //   } else {
  //     console.error("No option selected");
  //   }
  // };

  // const handleOptionSelect = (event) => {
  //   const selectedId = event.target.value;
  //   const selectedData = bodyData.find((item) => item._id === selectedId);
  //   setSelectedOption(selectedData);
  // };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOptionSelect = (event) => {
    const selectedId = event.target.value;
    setSelectedOption(selectedId);
    setAnchorEl(null);
  };

  const handleDeleteButtonClick = () => {
    if (selectedOption) {
      deleteBodyDataImages(selectedOption);
    } else {
      console.error("No option selected");
    }
  };
  // -------------------POST IMAGE DATA--------------------------//

  const [file, setFile] = useState([]);
  const [title, setTitle] = useState("");
  const [bodyMeasurement, setBodyMeasurement] = useState("");
  async function saveData() {
    const formData = new FormData();
    console.log(file, "fileee");
    formData.append("file", file);
    formData.append("title", title);
    formData.append("bodyMeasurement", bodyMeasurement);

    try {
      let result = await fetch(`${process.env.REACT_APP_BASE_URL}/bodyData/addBodyDataImage`, {
        method: "POST",
        body: formData,
      });

      if (result.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Data has been posted successfully!",
        });

        setFile(null);
        setBodyMeasurement("");
        setTitle("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to post data. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while posting data. Please try again later.",
      });
    }
  }

  
  //-------------------------------FILE-----------------------------------//
  const selectImages = (event) => {
    const files = event.target.files;
    const preview = document.querySelector("#preview");

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      const reader = new FileReader();

      reader.onload = function (e) {
        const image = new Image();
        image.src = e.target.result;
        image.style.width = "100px";
        image.style.height = "auto";

        preview.appendChild(image);
      };

      reader.readAsDataURL(file);
    }
    setFile([...file, files[0]]);
    console.log([...file, files[0]], event.target.files, "filess");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          {/* Upper text fields */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <TextField
              id="outlined-basic"
              sx={{ width: "20%" }}
              label="Name"
              variant="outlined"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />

            <TextField
              id="outlined-basic"
              sx={{ width: "20%" }}
              label="Type"
              variant="outlined"
              value={bodyMeasurement}
              onChange={(e) => setBodyMeasurement(e.target.value)}
              required
            />

            <div style={{ width: "50%", display: "flex" }}>
              <div style={{ marginRight: "10px", flex: 1 }}>
                <TextField
                  id="outlined-basic"
                  sx={{ width: "100%" }}
                  label="Body Measurement Type"
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={postData}
                          className="bg-purple-700 h-[5vh] rounded-md w-[5vw] text-sm cursor-pointer p-2 border-none outline-none text-white"
                        >
                          <AddIcon style={{ color: "green" }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <select
                  value={selectedOption ? selectedOption._id : ""}
                  onChange={handleOptionSelect}
                  style={{ marginRight: "8px", height: "36px", width: "200px" }}
                >
                  <option value="">Select an option</option>
                  {bodyData.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {selectedOption && (
                  <IconButton onClick={handleDeleteButtonClick}>
                    <MdDelete style={{ cursor: "pointer" }} />
                  </IconButton>
                )}
              </div>
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <TextField
              type="file"
              multiple
              onChange={selectImages}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
           
            <div id="preview"></div>
          </div>

          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <span
              className="bg-red-700 rounded-md cursor-pointer
               p-2 border-none outline-none text-white  text-sm"
              onClick={saveData}
            >
              Submit
            </span>
          </div>
        </form>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}
export default AddNewBmShape;
